export default function ConfirmDialog({ title, message, confirmLabel = 'Confirm', onConfirm, onCancel, loading }) {
  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header py-2">
            <h6 className="modal-title">{title}</h6>
          </div>
          <div className="modal-body">
            <div className="small">{message}</div>
          </div>
          <div className="modal-footer py-1">
            <button className="btn btn-sm btn-secondary" onClick={onCancel} disabled={loading}>Cancel</button>
            <button className="btn btn-sm btn-danger" onClick={onConfirm} disabled={loading}>
              {loading ? 'Working...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
